import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    fieldAndButton: {
      display: 'grid',
      gridGap: theme.spacing(0, 2),
      gridTemplateColumns: '1fr',
      [theme.breakpoints.up('md')]: {
        gridTemplateColumns: '1fr auto',
      },
    },
  };
};
